import moment from 'moment';
import React, { useCallback, useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { Header } from '../../../../base/components/Header';
import { BreadcrumbLink, HeaderWithBreadcrumbs } from '../../../../base/components/HeaderWithBreadcrumbs';
import { useAppDispatch, useAppSelector, useIsMobile } from '../../../../base/hooks';
import { __t } from '../../../../base/utils/t';
import { Helmet } from '../../../components/Helmet';
import { FilterSearch } from '../components/FilterSearch';
import { Navigation } from '../components/Navigation';
import { ResponsesTable } from '../components/ResponsesTable';
import { ResponseType } from '../enums';
import { responsesActions } from '../redux/slices/responsesSlice';

import './styles.scss';

export const ResponsesPage = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const appInitialized = useAppSelector((state) => state.employerApp.initialized);
    const referrer = useAppSelector((state) => state.app.referrer);
    const isMobile = useIsMobile();

    moment.locale(window.GLOBALS.language);

    useEffect(() => {
        if (!appInitialized) {
            return;
        }
        dispatch(responsesActions.fetchResponseTypeTabData());
    }, [location, appInitialized]);

    const breadcrumbs: BreadcrumbLink[] = [
        {
            text: __t('Головна'),
            url: '/',
        },
    ];

    const onBackClick = useCallback(() => {
        if (location.state?.from?.pathname) {
            navigate(location.state?.from?.pathname);
            return;
        }
        if (referrer) {
            window.location.href = referrer;
            return;
        }
    }, [referrer, location]);

    if (!appInitialized) {
        return null;
    }

    return (
        <>
            <Helmet pageName={__t('Відгуки')} />
            <div className='responses-page'>
                {isMobile ? (
                    <Header title={__t('Відгуки')} onBackClick={onBackClick} />
                ) : (
                    <HeaderWithBreadcrumbs links={breadcrumbs} current={__t('Відгуки')} title={__t('Відгуки')} />
                )}

                <Navigation className='responses-page__navigation' />
                <FilterSearch className='responses-page__filter-search' />

                <Routes>
                    <Route index element={<ResponsesTable type={ResponseType.Applied} />} />
                    <Route path='invited' element={<ResponsesTable type={ResponseType.Invited} />} />
                    <Route path='mutual' element={<ResponsesTable type={ResponseType.Mutual} />} />
                    <Route path='archived' element={<ResponsesTable type={ResponseType.Archive} />} />
                </Routes>
            </div>
        </>
    );
};
